import React, { useState, useEffect } from 'react';
import TestimonialsDgn from './testimonialsDesign';
import Carousel from './carousel';

const TestimonialsCarousel = () => {
    const cards = [
        {
            name: "Теодора",
            city: 'гр. София',
            pic: '1.png',
            quote: '“Невероятно отношение и професионализъм. Доволна съм от проведената досега подготовка по БЕЛ. Изключително професионално отношение към детето ми.”'
        },
        {
            name: "Денка",
            city: 'гр. Габрово',
            pic: '1.png',
            quote: '“Доволни сме. Уроците помагат за усвояване на материала и повишаване на успеха по математика.”'
        },
        {
            name: "Ива",
            city: 'гр. Габрово',
            pic: '1.png',
            quote: '“Детето ми напредна изключително много по БЕЛ след започване на уроците при вас. Всичко е точно и ясно организирано.”'
        },
        {
            name: "Петя",
            city: ' гр. София',
            pic: '1.png',
            quote: '“Отлично поднесен материал, с разбиране, придружен от приятна, интригуваща, вълнуваща учебна атмосфера. Благодарим! :)”'
        },
        {
            name: "Теодора",
            city: ' гр. София',
            pic: '1.png',
            quote: '“Благодаря за отношението към моето дете и индивидуалния подход към нея.”'
        },
        {
            name: "Аделина",
            city: ' гр. Калофер',
            pic: '1.png',
            quote: '“Изключително доволни. Отлично!”'
        },
        {
            name: "Валентина",
            city: ' гр. Ямбол',
            pic: '1.png',
            quote: '“Всичко е много добре. Отлично.”'
        },
        {
            name: "Зорница",
            city: '',
            pic: '1.png',
            quote: '“Вашият конкурс ми помогна изключително много за развитието на моята креативност!”'
        },
    ];

    return (
        <Carousel timerValue={10000} hideArrowsDesktop={true} spaceBetween={5} hideArrowsMobile={true} useTimer={true} elementsPerPage={3} elements={cards.map((card, index) => (
            <TestimonialsDgn key={index} name={card.name} quote={card.quote} pic={card.pic} city={card.city} />
        ))} />
    );
};

export default TestimonialsCarousel